import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { CircularProgress, Grid, Tooltip } from "@mui/material";
import {
  ApiResultModel,
  ColumnModel,
  PageInfoModel,
} from "../../../models/common.model";
import { useMutation, useQuery, useQueryClient } from "react-query";
import {
  FilterRegister,
  PaginationInfo,
  SearchLoanRegisterRequestsRequest,
  SearchLoanRequestsResponse,
} from "../../../models/loan.model";
import {
  Backdrop,
  Box,
  Button,
  FormControl,
  SelectChangeEvent,
  Typography,
} from "@mui/material";
import { GetStatusResponse } from "../../../models/basicInformation.model";
import {
  LOAN_REQUEST_STATUS_APP,
  LOAN_TEMPLATE_APP,
  SUPPLIER_ATTACHMENTS_UPLOADED,
  TABLE_FILTER_APP,
  TABLE_FILTER_APP_ROWNumber,
  WORK_FLOW_TYPE,
} from "../../../config/cacheKey";
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { useHistory, withRouter } from "react-router-dom";
import { createTheme } from "@mui/material/styles";
import rtlPlugin from "stylis-plugin-rtl";
import { prefixer } from "stylis";
import createCache from "@emotion/cache";
import useCollapse from "react-collapsed";
import { useEffect, useState } from "react";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import Pagination from "@mui/material/Pagination";
import PaginationItem from "@mui/material/PaginationItem";
import { connect, useDispatch, useSelector } from "react-redux";
import { Formik } from "formik";
import MaterialTextFieldComponent from "../../../components/textField/MaterialTextFieldCmp";
import { CacheProvider, ThemeProvider } from "@emotion/react";
import MultiSelectChip from "../../../components/dropdown/MultiSelectChip";
import DatePickerComponents from "../../../components/datePicker/DatePickerComponents";
import ChipCmp from "../../../components/chip/chipCmp";
import ChipComponent from "../../../components/chip/chipComponent";
import {
  exportLoanRegisterRequests,
  searchLoanRegisterRequests,
} from "../../../services/loan.service";
import { convertToLocalDateTime } from "../../../utility/dateUtility";
import {
  GetLoanRequestStatus,
  GetLoanTemplatesForApp,
  GetRegistrationStatus,
} from "../../../services/basicInformation.service";
import { debugPort } from "process";
import { FilterFinder } from "../../../models/cartable.model";
import { createStyles, Theme, makeStyles } from "@material-ui/core";
import Autocomplate from "../../../components/dropdown/Autocomplate";
import AutocomplateCheckbox from "../../../components/dropdown/AutocomplateCheckbox";

const nextIcon = () => {
  return (
    <img style={{ height: "12px", width: "10px" }} src='images/Next.png' />
  );
};
const previusIcon = () => {
  return (
    <img style={{ height: "12px", width: "10px" }} src='images/Previous.png' />
  );
};

const theme = createTheme({
  direction: "rtl", // Both here and <body dir="rtl">
});
// Create rtl cache
const cacheRtl = createCache({
  key: "muirtl",
  stylisPlugins: [prefixer, rtlPlugin],
});

const columns: readonly ColumnModel[] = [
  { id: "customerFullName", label: "متقاضی" },
  { id: "customerNationalCode", label: "کد ملی" },
  {
    id: "customerMobileNumber",
    label: "شماره همراه",
  },
  {
    id: "requestDatePersian",
    label: "تاریخ درخواست",
  },
  {
    id: "loanTemplateTitle",
    label: "طرح تسهیلات",
  },
  {
    id: "loanAmount",
    label: "مبلغ درخواستی (ریال)",
    hasFormat: true,
    format: (value: number) => {
      return value.toLocaleString("fa");
    },
  },
  {
    id: "stepSpace",
    label: " فاصله اقساط  ",
  },
  {
    id: "installmentCount",
    label: "تعداد اقساط  ",
  },
  {
    id: "loanRequestStatusTitle",
    label: "وضعیت درخواست",
  },
  {
    id: "loanRequestStatusUpdateDatePersian",
    label: " تاریخ آخرین وضعیت",
  },
  {
    id: "loanRequestStatusUpdateDatePersian",
    label: "تاریخ وضعیت تسهیلات ",
  },
  // {
  //   id: "loanRequestSourceTitle",
  //   label: "منبع درخواست",
  // },
];
let muiSelected: any;
function TableFindReqCmp({ stateCartable, status }: TableCmpPropsInterface) {
  let row: any;
  const jsonFile = useSelector((state: any) => state.style);

  muiSelected = jsonFile?.muiSelected;
  const useStyles = makeStyles((theme) =>
    createStyles({
      select: {
        "&.Mui-selected": {
          backgroundColor: muiSelected + "!important",
        },
      },
    })
  );
  const classes = useStyles();

  const activePage = localStorage.getItem("setActivePage");
  const queryClient = useQueryClient();
  queryClient.setQueryData(WORK_FLOW_TYPE, undefined);
  const oldPage = queryClient.getQueryData<FilterFinder>(
    TABLE_FILTER_APP_ROWNumber
  );
  // const history = useHistory();
  const history = useHistory<{
    from: string;
    id: string;
    pageNumber: number;
    clickOnBack: boolean;
    loanRequestId: number;
    natinalCode: string;
  }>();
  const [isExpanded, setExpanded] = useState(false);
  const [valueMultiSelect, setValueMultiSelect] = useState<string[]>([]);
  const [
    valueSupplierSettlementStatus,
    setValueSupplierSettlementStatus,
  ] = useState<string[]>([]);
  const [valueLoanRequestSources, setValueLoanRequestSources] = useState([]);
  const [valueLoanTemplateOptions, setValueLoanTemplateOptions] = useState<
    string[]
  >([]);
  const [valueLoanTemplate, setValueLoanTemplate] = useState<any[]>([]);
  const [valueSupplierUserOptions, setValueSupplierUserOptions] = useState([]);
  const [valueCustomerFullName, setValueCustomerFullName] = React.useState<
    string
  >();
  const [
    valueCustomerNationalCode,
    setValueCustomerNationalCode,
  ] = React.useState<string>();
  const [
    valueCustomerMobileNumber,
    setValueCustomerMobileNumber,
  ] = React.useState<string>();
  const [valueRequestDate, setValueRequestDate] = React.useState<string>();
  const [valueFilterData, setValueFilterData] = React.useState<
    FilterRegister
  >();
  const [valueStatusDate, setValueStatusDate] = React.useState<string>();

  const { getCollapseProps, getToggleProps } = useCollapse({
    isExpanded,
    collapsedHeight: 0,
  });
  const [data, setData] = React.useState<SearchLoanRequestsResponse[]>([]);
  const [pageInfo, setPageInfo] = React.useState<PageInfoModel>(
    (): PageInfoModel => {
      let pageInfoModel = new PageInfoModel();
      pageInfoModel.pageNumber = -1;
      pageInfoModel.pageSize = 10;
      pageInfoModel.total = 0;

      return pageInfoModel;
    }
  );
  const [currentPaginationInfo, setCurrentPaginationInfo] = React.useState(
    (): PaginationInfo => {
      let paginationInfo = new PaginationInfo();
      paginationInfo.pageNumber = 1;
      return paginationInfo;
    }
  );
  const [loanRequestStatus, setLoanRequestStatus] = React.useState<
    GetStatusResponse[]
  >([]);
  const [loanRequestOptions, setLoanRequestOptions] = React.useState<
    GetStatusResponse[]
  >([]);
  const [loanTemplateOptions, setLoanTemplateOptions] = React.useState<
    GetStatusResponse[]
  >([]);
  const [requestDate, setRequestDate] = React.useState<
    Date[] | null | undefined
  >(null);
  const [statusDate, setStatusDate] = React.useState<Date[] | null | undefined>(
    null
  );
  const [selectedRow, setSelectedRow] = useState(undefined);

  const previousPage =
    history.location.state !== undefined ? history.location.state.from : null;
  useQuery<GetStatusResponse[]>(LOAN_TEMPLATE_APP, GetLoanTemplatesForApp, {
    onSuccess(data) {
      setLoanTemplateOptions(data);
    },
  });
  useQuery<GetStatusResponse[]>(
    LOAN_REQUEST_STATUS_APP,
    GetRegistrationStatus,
    {
      onSuccess(data) {
        setLoanRequestStatus(data);
      },
    }
  );
  React.useEffect(() => {
    if (history.action === "POP" && oldPage?.rowNumber != undefined) {
      row = queryClient.getQueryData(TABLE_FILTER_APP_ROWNumber);
      setSelectedRow(row?.rowNumber);
    }
    if (
      (history.action === "PUSH" || history.action === "REPLACE") &&
      oldPage?.rowNumber == undefined
    ) {
      row = undefined;
      setSelectedRow(row);
    }
    if (history.action === "POP" && oldPage?.rowNumber == undefined) {
      row = undefined;
      setSelectedRow(row);
    }
    if (
      (history.action === "PUSH" || history.action === "REPLACE") &&
      oldPage?.rowNumber != undefined
    ) {
      row = queryClient.getQueryData(TABLE_FILTER_APP_ROWNumber);
      setSelectedRow(row?.rowNumber);
    }

    let filterData;
    if (
      previousPage !== null ||
      (history.action === "REPLACE" &&
        history.location.state !== undefined &&
        history.location.state.clickOnBack)
    ) {
      filterData = queryClient.getQueryData<FilterRegister>(TABLE_FILTER_APP);
      if (filterData !== undefined && filterData !== null) {
        setValueMultiSelect(filterData!.loanRequestStatus!);
        setValueLoanTemplateOptions(filterData?.loanTemplateIds!);
        setValueLoanTemplate(filterData!.valueLoanTemplate!);
        setValueCustomerFullName(filterData?.customerFullName!);
        setValueCustomerNationalCode(filterData?.customerNationalCode!);
        setValueCustomerMobileNumber(filterData?.customerMobileNumber!);
        setValueRequestDate(filterData?.requestDatePersian!);
        setValueStatusDate(filterData?.statusDatePersian!);
        setRequestDate(filterData?.requestDateArray!);
        setStatusDate(filterData?.statusDateArray!);
      }
    } else {
      // filter.state = stateCartable.stateCartable;
      filterData = new FilterRegister();
      filterData.customerFullName = "";
      filterData.customerNationalCode = "";
      filterData.customerMobileNumber = "";
      filterData.loanTemplateIds = [];
      filterData.loanRequestStatus = [];
      filterData.requestDateArray = [];
      filterData.requestDatePersian = "";
      filterData.statusDateArray = [];
      filterData.statusDatePersian = "";
      queryClient.setQueryData(TABLE_FILTER_APP, null);
    }
    fillData(filterData!);
    const filterApp = new FilterFinder();
    filterApp.state = stateCartable.stateCartable;
    queryClient.setQueryData(TABLE_FILTER_APP_ROWNumber, filterApp);
  }, []);

  const {
    mutateAsync: SearchLoanRegisterRequestsMutation,
    isLoading: isMutatinRegister,
  } = useMutation(searchLoanRegisterRequests, {
    onSuccess: (result: ApiResultModel<SearchLoanRequestsResponse[]>) => {
      if (result) {
        setData(result.data);
        let pageInfoModel = new PageInfoModel();
        pageInfoModel.pageNumber = -1;
        pageInfoModel.pageSize = 10;
        pageInfoModel.total = 0;
        setPageInfo(result.pageInfo != null ? result.pageInfo : pageInfoModel);
      }
    },
  });

  const ExportLoanRegisterRequestsMutation = useMutation(
    exportLoanRegisterRequests,
    {
      onSuccess: (result) => {},
      onError: (e) => {},
    }
  );

  const setChildValueStat = (childValues: any) => {
    const selectedItem = valueMultiSelect.filter(
      (item: any) => item != childValues
    );
    setValueMultiSelect(selectedItem);
    const tabelFilter = queryClient.getQueryData<FilterRegister>(
      TABLE_FILTER_APP
    );
    if (tabelFilter != undefined && tabelFilter != null) {
      tabelFilter!.loanRequestStatus = tabelFilter!.loanRequestStatus
        ?.filter((item: any) => item != childValues)
        .map((items: any) => {
          return items;
        });
    }
    fillData(tabelFilter!);
  };
  const setChildValueLoanTemplate = (childValues: any) => {
    const selectedItem = valueLoanTemplateOptions.filter(
      (item: any) => item != childValues
    );
    const selectedItemValue = valueLoanTemplate.filter(
      (item: any) => item.id != childValues
    );
    setValueLoanTemplateOptions(selectedItem);
    setValueLoanTemplate(selectedItemValue);

    const tabelFilter = queryClient.getQueryData<FilterRegister>(
      TABLE_FILTER_APP
    );
    if (tabelFilter != undefined && tabelFilter != null) {
      tabelFilter!.loanTemplateIds = tabelFilter!.loanTemplateIds
        ?.filter((item: any) => item != childValues)
        .map((items: any) => {
          return items;
        });
      tabelFilter!.valueLoanTemplate = tabelFilter!.valueLoanTemplate
        ?.filter((item: any) => item.id != childValues)
        .map((items: any) => {
          return items;
        });
    }
    fillData(tabelFilter!);
  };
  const setChildValueCustomerFullName = (childValues: any) => {
    const selectedItem = "";
    setValueCustomerFullName(selectedItem);
    const tabelFilter = queryClient.getQueryData<FilterRegister>(
      TABLE_FILTER_APP
    );
    if (tabelFilter != undefined && tabelFilter != null)
      tabelFilter!.customerFullName = undefined;
    fillData(tabelFilter!);
  };

  const setChildValueCustomerNationalCode = (childValues: any) => {
    const selectedItem = "";
    setValueCustomerNationalCode(selectedItem);
    const tabelFilter = queryClient.getQueryData<FilterRegister>(
      TABLE_FILTER_APP
    );
    if (tabelFilter != undefined && tabelFilter != null)
      tabelFilter!.customerNationalCode = undefined;
    fillData(tabelFilter!);
  };

  const setChildValueCustomerMobileNumber = (childValues: any) => {
    const selectedItem = "";
    setValueCustomerMobileNumber(selectedItem);
    const tabelFilter = queryClient.getQueryData<FilterRegister>(
      TABLE_FILTER_APP
    );
    if (tabelFilter != undefined && tabelFilter != null)
      tabelFilter!.customerMobileNumber = undefined;
    fillData(tabelFilter!);
  };

  const setChildValueRequestDate = (childValues: any) => {
    const selectedItem = "";
    setValueRequestDate(selectedItem);
    setRequestDate(undefined);
    const tabelFilter = queryClient.getQueryData<FilterRegister>(
      TABLE_FILTER_APP
    );
    if (tabelFilter != undefined && tabelFilter != null) {
      tabelFilter!.requestDateFrom = undefined;
      tabelFilter!.requestDateTo = undefined;
      tabelFilter!.requestDatePersian = "";
      tabelFilter!.requestDateArray = [];
    }

    fillData(tabelFilter!);
  };

  const setChildValueStatusDate = (childValues: any) => {
    const selectedItem = "";
    setValueStatusDate(selectedItem);
    setStatusDate(undefined);

    const tabelFilter = queryClient.getQueryData<FilterRegister>(
      TABLE_FILTER_APP
    );
    if (tabelFilter != undefined && tabelFilter != null) {
      tabelFilter!.statusDateFrom = undefined;
      tabelFilter!.statusDateTo = undefined;
      tabelFilter!.statusDateArray = [];
      tabelFilter!.statusDatePersian = "";
    }
    fillData(tabelFilter!);
  };

  const generateFilter = (
    filterData: FilterRegister
  ): SearchLoanRegisterRequestsRequest => {
    let request = new SearchLoanRegisterRequestsRequest();
    request.paginationInfo = currentPaginationInfo;
    request.filter = filterData;
    if (request.filter != undefined)
      request.filter.cartableTitle = "درخواست های ثبت نام";

    //checked
    // request.filter.state = stateCartable.stateCartable;
    return request;
  };

  const fillData = (filterData: FilterRegister) => {
    let filter = generateFilter(filterData);
    SearchLoanRegisterRequestsMutation(filter);
    setValueFilterData(filter?.filter);
  };

  const changePageNumber = (newPageNumber: number) => {
    const tabelFilter = queryClient.getQueryData<FilterRegister>(
      TABLE_FILTER_APP
    );
    fillData(tabelFilter!);
    currentPaginationInfo.pageNumber = newPageNumber;
    setCurrentPaginationInfo(currentPaginationInfo);
    // fillData(new Filter())
  };

  const handleChangePage = (event: unknown, newPage: number) => {
    changePageNumber(newPage + 1);
  };
  const handleChangePagination = (event: any, value: any) => {
    changePageNumber(value);
    handleSelectRow(undefined);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    alert("handleChangeRowsPerPage");
    // setRowsPerPage(+event.target.value);
    // setPage(0);
  };

  const handleChangeMultiselect = (
    event: SelectChangeEvent<typeof loanRequestOptions>
  ) => {
    const {
      target: { value },
    } = event;
  };
  const disposeListener = history.listen((navData) => {
    if (
      navData.pathname === "/Search/CustomerSearch" &&
      history.location.state !== undefined &&
      history.location.state.pageNumber!
    ) {
      currentPaginationInfo.pageNumber = history.location.state.pageNumber;
      setCurrentPaginationInfo(currentPaginationInfo);
    }
  });
  const handleDetail = (
    referenceKey: string,
    rowIndex: number,
    loanRequestId: number,
    natinalCode: string
  ) => {
    window.sessionStorage.setItem("idFind", referenceKey);
    window.sessionStorage.setItem("loanRequestId", loanRequestId.toString());
    window.sessionStorage.setItem("natinalCode", natinalCode);
    handleSelectRow(rowIndex);
    queryClient.setQueryData(SUPPLIER_ATTACHMENTS_UPLOADED, null);
    //history.push(`/loan-detail/${referenceKey}`);
    history.push({
      // pathname: `/Search/CustomerSearch1/request-find-detail`,
      pathname: `/Search/${activePage}1/request-find-detail`,
      state: {
        id: referenceKey,
        from: "",
        pageNumber: currentPaginationInfo.pageNumber!,
        clickOnBack: false,
        loanRequestId: loanRequestId,
        natinalCode: natinalCode,
      },
    });
  };
  const handleSelectRow = (rowIndex: any) => {
    const cachPageNumber = queryClient.getQueryData(
      TABLE_FILTER_APP_ROWNumber
    ) as FilterFinder;
    const filter = new FilterFinder();
    filter.rowNumber = rowIndex;
    setSelectedRow(rowIndex);
    queryClient.setQueryData(TABLE_FILTER_APP_ROWNumber, filter);
  };
  function handelCollapse() {
    setExpanded(!isExpanded);
  }
  function changeMultiSelectChip(e: any) {
    setValueMultiSelect(e);
  }
  function changeValueSupplierSettlementStatus(e: any) {
    setValueSupplierSettlementStatus(e);
  }
  function changeValueLoanRequestSources(e: any) {
    setValueLoanRequestSources(e);
  }
  function changeValueLoanTemplateOptions(e: any, value: any) {
    setValueLoanTemplateOptions(e);
    setValueLoanTemplate(value);
  }

  function changeValueCustomerFullName(e: any) {
    setValueCustomerFullName(e.currentTarget.value);
  }
  function changeValueCustomerNationalCode(e: any) {
    setValueCustomerNationalCode(e.currentTarget.value);
  }
  function changeValueCustomerMobileNumber(e: any) {
    setValueCustomerMobileNumber(e.currentTarget.value);
  }
  function changeValueRequestDate(e: any) {
    setRequestDate(e);
    setValueRequestDate(e.toString());
  }
  function changeValueStatusDate(e: any) {
    setStatusDate(e);
    setValueStatusDate(e.toString());
  }
  function deleteChip() {
    setValueMultiSelect([]);
    setValueLoanTemplateOptions([]);
    setValueLoanTemplate([]);
    setValueCustomerFullName("");
    setValueCustomerNationalCode("");
    setValueCustomerMobileNumber("");
    setValueRequestDate("");
    setValueStatusDate("");
    setStatusDate([]);
    setRequestDate([]);

    queryClient.setQueryData(TABLE_FILTER_APP, null);
    fillData(queryClient.getQueryData(TABLE_FILTER_APP)!);
    currentPaginationInfo.pageNumber = 1;
    setCurrentPaginationInfo(currentPaginationInfo);
  }
  const filter = new FilterRegister();
  filter.loanRequestStatus = [];
  filter.loanTemplateIds = [];
  const lessFilter = (
    <span style={{ textAlign: "center" }}>
      <ArrowDropUpIcon style={{ color: "#1D4A87" }} />
      فیلترهای کمتر{" "}
    </span>
  );
  const extraFilter = (
    <span style={{ textAlign: "center" }}>
      <ArrowDropDownIcon style={{ color: "#1D4A87" }} />
      فیلترهای بیشتر
    </span>
  );

  const handleClick = () => {
    console.info("You clicked the Chip.");
  };

  const handleDelete = () => {
    console.info("You clicked the delete icon.");
  };
  const [isShow, setIsShow] = useState(true);
  let handelFilter = () => {
    setIsShow(!isShow);
  };
  let exportExcel = () => {
    ExportLoanRegisterRequestsMutation.mutate(
      valueFilterData ? valueFilterData! : new FilterRegister()
    );
  };

  return (
    <>
      {/* <Button onClick={handelFilter}> */}
      <Tooltip title='فیلتر ' arrow>
        <img
          onClick={handelFilter}
          style={{ width: "24px", height: "24px", marginBottom: ".5vh" }}
          src='images/filter.png'
        />
      </Tooltip>

      <span style={{ margin: "2vh", color: "#CFD8DC" }}>|</span>
      <Tooltip title='خروجی اکسل' arrow>
        <img
          onClick={exportExcel}
          className='cursorPointer'
          style={{ width: "24px", height: "24px", marginBottom: ".5vh" }}
          src='images/ExportXLS.svg'
        />
      </Tooltip>
      {/* </Button> */}
      {isShow ? (
        <Box sx={{ flexGrow: 1 }}>
          <Formik
            initialValues={filter}
            onSubmit={(values) => {
              if (
                requestDate != null &&
                (requestDate[0] != undefined || requestDate[1] != undefined)
              ) {
                values.requestDateFrom = convertToLocalDateTime(
                  Number(requestDate[0])
                );
                if (requestDate?.length > 1) {
                  values.requestDateTo = convertToLocalDateTime(
                    Number(requestDate[1])
                  );
                } else {
                  values.requestDateTo = convertToLocalDateTime(
                    Number(requestDate[0])
                  );
                }
              } else {
                values.requestDateTo = undefined;
                values.requestDateFrom = undefined;
              }

              if (
                statusDate != null &&
                (statusDate[0] != undefined || statusDate[1] != undefined)
              ) {
                values.statusDateFrom = convertToLocalDateTime(
                  Number(statusDate[0])
                );
                if (statusDate?.length > 1) {
                  values.statusDateTo = convertToLocalDateTime(
                    Number(statusDate[1])
                  );
                } else {
                  values.statusDateTo = convertToLocalDateTime(
                    Number(statusDate[0])
                  );
                }
              } else {
                values.statusDateFrom = undefined;
                values.statusDateTo = undefined;
              }

              values.requestDatePersian = valueRequestDate;
              values.requestDateArray = requestDate;
              values.statusDatePersian = valueStatusDate;
              values.statusDateArray = statusDate;

              queryClient.setQueryData(TABLE_FILTER_APP, values);
              values.loanRequestStatus = valueMultiSelect;
              values.loanTemplateIds = valueLoanTemplateOptions;
              values.valueLoanTemplate = valueLoanTemplate;
              values.customerFullName = valueCustomerFullName;
              values.customerNationalCode = valueCustomerNationalCode;
              values.customerMobileNumber = valueCustomerMobileNumber;
              fillData(values);
              currentPaginationInfo.pageNumber = 1;
              setCurrentPaginationInfo(currentPaginationInfo);
            }}
          >
            {({ handleSubmit, handleChange, values }) => (
              <form onSubmit={handleSubmit}>
                <div className='row'>
                  <div
                    className='col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12'
                    style={{ marginTop: "1vh" }}
                  >
                    <MaterialTextFieldComponent
                      // className="shadowTextField"
                      helperText={""}
                      placeHolder={"نام و نام خانوادگی متقاضی"}
                      label={"نام و نام خانوادگی متقاضی"}
                      required={false}
                      value={valueCustomerFullName}
                      onChange={changeValueCustomerFullName}
                      name='customerFullName'
                      id='customerFullName'
                    />
                  </div>
                  <div
                    className='col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12'
                    style={{ marginTop: "1vh" }}
                  >
                    <MaterialTextFieldComponent
                      // className="shadowTextField"
                      helperText={""}
                      placeHolder={"کد ملی"}
                      label={"کد ملی "}
                      required={false}
                      value={valueCustomerNationalCode}
                      onChange={changeValueCustomerNationalCode}
                      name='customerNationalCode'
                      id='customerNationalCode'
                    />
                  </div>
                  <div
                    className='col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12'
                    style={{ marginTop: "1vh" }}
                  >
                    <MaterialTextFieldComponent
                      // className="shadowTextField"
                      helperText={""}
                      placeHolder={"شماره همراه"}
                      label={"شماره همراه"}
                      required={false}
                      value={valueCustomerMobileNumber}
                      onChange={changeValueCustomerMobileNumber}
                      name='customerMobileNumber'
                      id='customerMobileNumber'
                    />
                  </div>
                  <div
                    className='col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12'
                    style={{ marginTop: "1vh" }}
                  >
                    <CacheProvider value={cacheRtl}>
                      <ThemeProvider theme={theme}>
                        <div dir='rtl'>
                          <MultiSelectChip
                            id='loanRequestStatus'
                            name='loanRequestStatus'
                            value={valueMultiSelect}
                            label='وضعیت درخواست'
                            options={loanRequestStatus}
                            onChange={changeMultiSelectChip}
                            changeMultiSelect={changeMultiSelectChip}
                          />
                        </div>
                      </ThemeProvider>
                    </CacheProvider>
                  </div>
                  <div
                    className='col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12'
                    style={{ marginTop: "1vh" }}
                  >
                    <FormControl fullWidth className='shadowDatepicker'>
                      <DatePickerComponents
                        valueArray={requestDate}
                        label={"تاریخ درخواست"}
                        // onChange={(newValue: any) => {
                        //   setRequestDateFrom(newValue);
                        // }}
                        onChange={changeValueRequestDate}
                        range={true}
                      />
                    </FormControl>
                  </div>

                  <div
                    className='col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12'
                    style={{ marginTop: "1vh" }}
                  >
                    <FormControl fullWidth className='shadowDatepicker'>
                      <DatePickerComponents
                        valueArray={statusDate}
                        label={"تاریخ آخرین وضعیت "}
                        // onChange={(newValue: any) => {
                        //   setStatusDateFrom(newValue);
                        // }}
                        onChange={changeValueStatusDate}
                        range={true}
                      />
                    </FormControl>
                  </div>

                  <div
                    className='col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12'
                    style={{ marginTop: "1vh" }}
                  >
                    <CacheProvider value={cacheRtl}>
                      <ThemeProvider theme={theme}>
                        <div dir='rtl'>
                          {/* <MultiSelectChip
                            id="loanTemplateOptions"
                            name="loanTemplateOptions"
                            value={valueLoanTemplateOptions}
                            label="طرح تسهیلات"
                            options={loanTemplateOptions}
                            onChange={changeValueLoanTemplateOptions}
                            changeMultiSelect={changeValueLoanTemplateOptions}
                          /> */}
                          <AutocomplateCheckbox
                            id='loanTemplateIds'
                            name='loanTemplateIds'
                            value={valueLoanTemplateOptions}
                            label='طرح تسهیلات'
                            options={loanTemplateOptions}
                            onChange={changeValueLoanTemplateOptions}
                            changeMultiSelect={changeValueLoanTemplateOptions}
                            responseValue={valueLoanTemplate}
                          />
                        </div>
                      </ThemeProvider>
                    </CacheProvider>
                  </div>

                  <div
                    className='col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12 butFilter'
                    style={{ marginTop: "1vh" }}
                  >
                    <Button
                      fullWidth
                      variant='contained'
                      type='submit'
                      className='btnForm SuccessDefault  '
                    >
                      اعمال فیلتر
                    </Button>
                  </div>
                </div>
                {valueMultiSelect?.length ||
                valueSupplierSettlementStatus?.length ||
                valueLoanTemplateOptions?.length ||
                valueLoanRequestSources?.length ||
                valueSupplierUserOptions?.length ||
                valueCustomerFullName ||
                valueCustomerNationalCode ||
                valueCustomerMobileNumber ||
                valueRequestDate ||
                valueStatusDate ? (
                  <div className='row tableCMP'>
                    <Grid container xs={12}>
                      <Grid item xs={12} sm={0.5}>
                        <Button
                          onClick={deleteChip}
                          style={{
                            justifyContent: "right",
                            minWidth: "25px",
                            marginRight: "-1vh",
                          }}
                        >
                          <img
                            style={{ height: "24px", width: "24px" }}
                            src='images/RemoveAllFilters.svg'
                          />
                        </Button>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        sm={11.5}
                        style={{ marginTop: "-9px" }}
                      >
                        <ChipCmp
                          item={valueMultiSelect}
                          enamValue={loanRequestStatus}
                          index={valueMultiSelect?.length}
                          setChildValue={setChildValueStat}
                        />
                        <ChipCmp
                          item={valueLoanTemplateOptions}
                          enamValue={loanTemplateOptions}
                          index={valueLoanTemplateOptions?.length}
                          setChildValue={setChildValueLoanTemplate}
                        />
                        <ChipCmp
                          item={valueCustomerFullName}
                          enamValue={valueCustomerFullName}
                          index={valueCustomerFullName?.length}
                          setChildValue={setChildValueCustomerFullName}
                        />
                        <ChipCmp
                          item={valueCustomerNationalCode}
                          enamValue={valueCustomerNationalCode}
                          index={valueCustomerNationalCode?.length}
                          setChildValue={setChildValueCustomerNationalCode}
                        />
                        <ChipCmp
                          item={valueCustomerMobileNumber}
                          enamValue={valueCustomerMobileNumber}
                          index={valueCustomerMobileNumber?.length}
                          setChildValue={setChildValueCustomerMobileNumber}
                        />
                        <ChipCmp
                          item={valueRequestDate}
                          enamValue={valueRequestDate}
                          index={valueRequestDate?.length}
                          setChildValue={setChildValueRequestDate}
                        />
                        <ChipCmp
                          item={valueStatusDate}
                          enamValue={valueStatusDate}
                          index={valueStatusDate?.length}
                          setChildValue={setChildValueStatusDate}
                        />
                      </Grid>
                    </Grid>
                  </div>
                ) : (
                  ""
                )}
              </form>
            )}
          </Formik>
        </Box>
      ) : (
        ""
      )}
      <br />
      {
        // isMutatinRegister ? (
        //   <>
        //     <Backdrop
        //       hidden={false}
        //       open={true}
        //       sx={{ color: "#fff", zIndex: () => 1 }}
        //     >
        //       <CircularProgress color="inherit" />
        //     </Backdrop>
        //   </>
        // ) :
        <>
          <div className='cardTableBorder'>
            <TableContainer
              style={{ background: "#fff", maxHeight: "55vh" }}
              className='boxScroll'
            >
              <Table
                stickyHeader
                aria-label='sticky table'
                style={{ borderCollapse: "collapse" }}
              >
                <TableHead
                  className='rowTHead'
                  style={{ paddingBottom: "10px" }}
                >
                  <TableRow
                    classes={{ root: classes.select }}
                    className={`${classes} borderRight borderLeft`}
                    selected={selectedRow === 0}
                  >
                    <TableCell
                      className='rowTHead colorTitle textFont12 fontWeight'
                      align='right'
                      style={{ width: "10vh", minWidth: "10vh" }}
                    >
                      #
                    </TableCell>
                    {columns.map((column) => (
                      <TableCell
                        className='rowTHead colorTitle textFont12 fontWeight noWrap'
                        key={column.id}
                        align='right'
                      >
                        {column.label}
                      </TableCell>
                    ))}
                    <TableCell
                      className='rowTHead colorTitle stickyColO'
                      align='right'
                    >
                      <MoreHorizIcon
                        scale='scale(1.8) '
                        style={{ color: "#1D4A87" }}
                      />
                    </TableCell>
                  </TableRow>
                </TableHead>
                <div style={{ width: "100%", height: "10px" }}></div>
                <TableBody>
                  {data
                    ? data.map((row, rowIndex) => {
                        return (
                          <TableRow
                            classes={{ root: classes.select }}
                            className={`${
                              rowIndex % 2 == 0 ? "rowTBodyE  " : "rowTBodyO "
                            } ${classes} borderRight borderLeft cursorPointer noWrap`}
                            hover
                            role='checkbox'
                            tabIndex={-1}
                            key={row.loanRequestId}
                            selected={selectedRow === rowIndex}
                            onClick={() =>
                              handleDetail(
                                row.referenceKey,
                                rowIndex,
                                row.loanRequestId,
                                row.customerNationalCode
                              )
                            }
                          >
                            <TableCell
                              className='textFont12'
                              style={{ width: "10vh", minWidth: "10vh" }}
                            >
                              {((currentPaginationInfo.pageNumber ?? 0) - 1) *
                                (currentPaginationInfo.pageSize! ?? 0) +
                                rowIndex +
                                1}
                            </TableCell>
                            {columns.map((column) => {
                              const value =
                                row[
                                  column.id as keyof SearchLoanRequestsResponse
                                ];
                              return (
                                <TableCell
                                  className='textFont12'
                                  key={column.id}
                                  align='right'
                                >
                                  {column.format && column.hasFormat
                                    ? column.format(value)
                                    : value?.toString()}
                                </TableCell>
                              );
                            })}
                            <TableCell
                              className={
                                rowIndex % 2 == 0
                                  ? " stickyColO   "
                                  : " stickyColE  "
                              }
                            >
                              <MoreHorizIcon
                                scale='scale(1.8) '
                                className='cursorPointer'
                                style={{ color: "#1D4A87" }}
                                onClick={() =>
                                  handleDetail(
                                    row.referenceKey,
                                    rowIndex,
                                    row.loanRequestId,
                                    row.customerNationalCode
                                  )
                                }
                              />
                            </TableCell>
                          </TableRow>
                        );
                      })
                    : null}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
          <div>
            <div className='row'></div>
            <Grid container xs={12}>
              <Grid item xs={4}>
                <span
                  style={{ color: "#1D4A87", top: "1vh", position: "relative" }}
                >
                  تعداد کل :
                  <span style={{ color: "#01AF43" }}>{pageInfo?.total}</span>{" "}
                  مورد
                </span>
              </Grid>
              <Grid item xs={4}>
                <Pagination
                  renderItem={(item) => (
                    <PaginationItem
                      components={{
                        previous: previusIcon,
                        next: nextIcon,
                      }}
                      {...item}
                    />
                  )}
                  // color="primary"
                  sx={{
                    display: "flex",
                    justifyContent: "center !important",
                    direction: "ltr",
                    margin: "5px",
                    button: {
                      color: "#25D1C9",
                      fontSize: "14px !important",
                      fontFamily: "iranSans",
                    },
                    //  button.sele
                  }}
                  count={
                    pageInfo
                      ? Math.ceil(pageInfo?.total / pageInfo?.pageSize)
                      : 0
                  }
                  onChange={handleChangePagination}
                  page={currentPaginationInfo.pageNumber}
                />
              </Grid>
              <Grid item xs={4}></Grid>
            </Grid>
          </div>
        </>
      }
    </>
  );
}
interface TableCmpPropsInterface {
  stateCartable: any;
  status: any;
}
const mapStateToProps = ({ stateCartable, status }: TableCmpPropsInterface) => {
  return {
    stateCartable,
    status,
  };
};

export default withRouter(connect(mapStateToProps)(TableFindReqCmp));
const onKeyDown = (e: any) => {
  e.preventDefault();
};
